import { render, staticRenderFns } from "./DevicesLayer.vue?vue&type=template&id=c2470b68&scoped=true"
import script from "./DevicesLayer.vue?vue&type=script&lang=js"
export * from "./DevicesLayer.vue?vue&type=script&lang=js"
import style0 from "./DevicesLayer.vue?vue&type=style&index=0&id=c2470b68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2470b68",
  null
  
)

export default component.exports